export default {
  loading: false,
  contacts: [],
  search: '',
  contactSingleSelection: true,
  contactsSelectionLimit: 49,
  currentChannel: '',
  currentChannelData: {},
  channels: [],
  privateChannel: '',
  messages: {},
  activeWriters: {},
  uuid: '',
  chatIsActive: false,
  channelWithFullHistory: {},
  historyMessagesCounter: 25, // max possible value (pubnub limitation)
  initializedChannels: {},
  unreadMessagesObject: {},
  initChatMembers: {}
}
